import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmButtonModule, MmDialogModule, MmIconModule } from '@metromarkets/components';

import { AdvancedFormModule } from '~shared/modules/advanced-form/advanced-form.module';
import { ExtendImpersonationSessionDialogComponent } from './extend-impersonation-session-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    QaLocatorsModule,
    MmDialogModule,
    MmButtonModule,
    MmIconModule,
    AdvancedFormModule,
  ],
  declarations: [ExtendImpersonationSessionDialogComponent],
  exports: [ExtendImpersonationSessionDialogComponent],
})
export class AppExtendImpersonationSessionDialogModule {}
